module.exports = __webpack_public_path__ + "static/img/91.62f1af98.jpg";